import { queryOptions, useQuery } from "@tanstack/react-query";
import { api } from "@/lib/http";

export type Policy = {
  /** Human readable name */
  name: string;
  /** Human readable description */
  description: string;
  entities: Array<string>;
  entities_aggregated: Array<string>;
};

type Policies = Record<string, Policy>;

function getPolicies() {
  return api.governance.get<Policies>("gcp/pii/full_policy_list").json();
}

export const governancePoliciesQueryOptions = queryOptions({
  queryKey: ["governance", "policies"],
  queryFn: getPolicies,
});

export function useGovernancePolicies() {
  return useQuery(governancePoliciesQueryOptions);
}
